import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import EducationLevelsPage from "./pages/EducationLevelsPage";
import AdmissionsPage from "./pages/AdmissionsPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import NotFoundPage from "./pages/NotFoundPage";
import AdminLogin from "./pages/admin/AdminLogin";
import Dashboard from "./pages/admin/Dashboard";
import AdminDashboard from "./pages/admin/AdminDashboard";
import NewsManagement from "./pages/admin/NewsManagement";
import EventsManagement from "./pages/admin/EventsManagement";
import AchievementsManagement from "./pages/admin/AchievementsManagement";
import AboutPageManagement from "./pages/admin/AboutPageManagement";
import EducationLevelsManagement from "./pages/admin/EducationLevelsManagement";
import AdmissionsPageManagement from "./pages/admin/AdmissionsPageManagement";
import ContactPageManagement from "./pages/admin/ContactPageManagement";
import SiteSettingsManagement from "./pages/admin/SiteSettingsManagement";
import CoreValuesManagement from "./pages/admin/CoreValuesManagement";
import MessagesManagement from "./pages/admin/MessagesManagement";
import LegalPagesManagement from "./pages/admin/LegalPagesManagement";
import { Toaster } from "./components/ui/sonner";
import WhatsAppButton from "./components/WhatsAppButton";
import PhoneButton from "./components/PhoneButton";
import ScrollToTop from "./components/ScrollToTop";
import SEOHead from "./components/SEOHead";

function AppContent() {
  const location = useLocation();
  
  // LandingPage ve admin sayfalarında WhatsApp butonunu gösterme
  const shouldShowWhatsApp = 
    location.pathname !== "/" && 
    !location.pathname.startsWith("/admin") &&
    location.pathname !== "/sahinserpil4409";

  return (
    <>
      <SEOHead />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/kolej" element={<HomePage />} />
        <Route path="/hakkimizda" element={<AboutPage />} />
        <Route path="/egitim-kademeleri" element={<EducationLevelsPage />} />
        <Route path="/kabul" element={<AdmissionsPage />} />
        <Route path="/iletisim" element={<ContactPage />} />
        <Route path="/gizlilik-politikasi" element={<PrivacyPolicyPage />} />
        <Route path="/kullanim-sartlari" element={<TermsOfServicePage />} />
        
        {/* Admin Routes */}
        <Route path="/sahinserpil4409" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<Dashboard />} />
        <Route path="/admin/haberler" element={<NewsManagement />} />
        <Route path="/admin/etkinlikler" element={<EventsManagement />} />
        <Route path="/admin/basarilar" element={<AchievementsManagement />} />
        <Route path="/admin/hakkimizda" element={<AboutPageManagement />} />
        <Route path="/admin/egitim-kademeleri" element={<EducationLevelsManagement />} />
        <Route path="/admin/kabul" element={<AdmissionsPageManagement />} />
        <Route path="/admin/iletisim" element={<ContactPageManagement />} />
        <Route path="/admin/site-ayarlari" element={<SiteSettingsManagement />} />
        <Route path="/admin/mesajlar" element={<MessagesManagement />} />
        <Route path="/admin/core-values" element={<CoreValuesManagement />} />
        <Route path="/admin/yasal-sayfalar" element={<LegalPagesManagement />} />
        
        {/* 404 - Catch all unmatched routes */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <Toaster richColors position="top-right" />
      {shouldShowWhatsApp && (
        <>
          <PhoneButton />
          <WhatsAppButton />
        </>
      )}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;